var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66521 6.96803L8.94117 5.58823L9.21713 6.96803C9.72681 9.51645 11.7188 11.5085 14.2673 12.0181L15.6471 12.2941L14.2673 12.5701C11.7188 13.0797 9.72681 15.0718 9.21713 17.6202L8.94117 19L8.66521 17.6202C8.15554 15.0718 6.16352 13.0797 3.61509 12.5701L2.23529 12.2941L3.61509 12.0181C6.16352 11.5085 8.15554 9.51645 8.66521 6.96803Z",
    fill: "#8a8a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21496 4.04284L3.35294 3.35294L3.49092 4.04284C3.74577 5.31704 4.74176 6.31305 6.01598 6.5679L6.70588 6.70588L6.01598 6.84386C4.74176 7.09868 3.74577 8.09469 3.49092 9.36892L3.35294 10.0588L3.21496 9.36892C2.96011 8.09469 1.9641 7.09868 0.689901 6.84386L0 6.70588L0.689901 6.5679C1.9641 6.31305 2.96011 5.31704 3.21496 4.04284Z",
    fill: "#8a8a8a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2278 0.919885L13.4117 0L13.5957 0.919885C13.9355 2.61883 15.2635 3.94681 16.9625 4.28661L17.8823 4.47062L16.9625 4.65457C15.2635 4.99437 13.9355 6.32235 13.5957 8.02129L13.4117 8.94118L13.2278 8.02129C12.888 6.32235 11.56 4.99437 9.86105 4.65457L8.94116 4.47062L9.86105 4.28661C11.56 3.94681 12.888 2.61883 13.2278 0.919885Z",
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.618f5746266447a86a65723ef3a83971.svg";
export { ForwardRef as ReactComponent };